import { IndicatorType } from '../../constants/common'
import IndicatorBaseConfig from './indicatorBaseConfig'

export class NoneConfig extends IndicatorBaseConfig {
  static type = IndicatorType.None
  static abbreviation = 'none'
  static label = 'None'
  static shortLabel = 'None'
}
